import { render, staticRenderFns } from "./UrlPopup.vue?vue&type=template&id=c46c3cd2&scoped=true"
import script from "./UrlPopup.vue?vue&type=script&lang=js"
export * from "./UrlPopup.vue?vue&type=script&lang=js"
import style0 from "./UrlPopup.vue?vue&type=style&index=0&id=c46c3cd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46c3cd2",
  null
  
)

export default component.exports